import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/tab';
import Modal from 'bootstrap/js/dist/modal';
import hcOffcanvasNav from 'hc-offcanvas-nav';
import Rellax from "rellax"
import AOS from "aos"
import { lazyloadVideoElement, lazyloadiFrameElement, backgroundImageLazyLoad } from 'utils/lazyload';
import { navigation, bodyOverlay, navigationFunctions } from 'components/nav';
import { initSwiper, caseStudiesSlider, galleryWithThumbnails } from 'components/sliders';
import googleMaps from 'components/map';
import initDownloadsPage from 'pages/downloads-page';
import initNewsResultsPage from 'pages/news-page';
import initSearch from 'components/search';
import { readmore, readless } from './components/readmore';

//* Animation libraries
const rellax = new Rellax('.rellax');
// For AOS to work we have also included the CSS in the header.php file.
AOS.init({
	duration: 400
}); 
//*

//* Stats counters
const counters = document.querySelectorAll(".count");
    const speed = 200;

    counters.forEach((counter) => {
        const updateCount = () => {
            const target = parseInt(+counter.getAttribute("data-target"));
            const count = parseInt(+counter.innerText);
            //const increment = Math.trunc(target / speed);
            const increment = Math.trunc(1);
            console.log(increment);

            if (count < target) {
                counter.innerText = count + increment;
                setTimeout(updateCount, 1);
            } else {
                count.innerText = target;
            }
        };
        updateCount();
    });
//*

$(function () {
	// Utilities
	backgroundImageLazyLoad();
	lazyloadiFrameElement();
	lazyloadVideoElement();

	// Navigation
	navigationFunctions(navigation);
	bodyOverlay();

	// Components
	initSearch();

	//Sliders
	initSwiper();
	caseStudiesSlider();
	// galleryWithThumbnails();
	readmore();
	readless();

	// Google Maps
	//googleMaps();

	// Pages
	initDownloadsPage();
	initNewsResultsPage();

});
